var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar", { attrs: { title: "New Company" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { column: "" } },
            [
              _c(
                "v-card",
                { staticClass: "py-2 pl-5" },
                [
                  _c("v-layout", { attrs: { "align-baseline": "" } }, [
                    _c("div", { staticClass: "title mr-3 mt-4" }, [
                      _vm._v("\n            New Company\n          ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "", sm6: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Company Name",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.companyName,
                                  callback: function($$v) {
                                    _vm.companyName = $$v
                                  },
                                  expression: "companyName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "EIN" },
                                model: {
                                  value: _vm.ein,
                                  callback: function($$v) {
                                    _vm.ein = $$v
                                  },
                                  expression: "ein"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Contact Name",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.contactName,
                                  callback: function($$v) {
                                    _vm.contactName = $$v
                                  },
                                  expression: "contactName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Contact Email",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.contactEmail,
                                  callback: function($$v) {
                                    _vm.contactEmail = $$v
                                  },
                                  expression: "contactEmail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", {
                            staticClass: "mr-5",
                            attrs: { sm3: "" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Phone",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.contactPhone,
                                  callback: function($$v) {
                                    _vm.contactPhone = $$v
                                  },
                                  expression: "contactPhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Website URL",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.website,
                                  callback: function($$v) {
                                    _vm.website = $$v
                                  },
                                  expression: "website"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Logo URL",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.logoUrl,
                                  callback: function($$v) {
                                    _vm.logoUrl = $$v
                                  },
                                  expression: "logoUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Night Contact Name",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.nightContactName,
                                  callback: function($$v) {
                                    _vm.nightContactName = $$v
                                  },
                                  expression: "nightContactName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Night Phone",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.nightPhone,
                                  callback: function($$v) {
                                    _vm.nightPhone = $$v
                                  },
                                  expression: "nightPhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-layout", { attrs: { "align-baseline": "" } }, [
                    _c("div", { staticClass: "title mr-3 mt-4" }, [
                      _vm._v("\n            Address\n          ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "", sm6: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Street",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.addressStreet1,
                                  callback: function($$v) {
                                    _vm.addressStreet1 = $$v
                                  },
                                  expression: "addressStreet1"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "City",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.addressCity,
                                  callback: function($$v) {
                                    _vm.addressCity = $$v
                                  },
                                  expression: "addressCity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Suite or Building Number",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.addressStreet2,
                                  callback: function($$v) {
                                    _vm.addressStreet2 = $$v
                                  },
                                  expression: "addressStreet2"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "State",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.addressRegion,
                                  callback: function($$v) {
                                    _vm.addressRegion = $$v
                                  },
                                  expression: "addressRegion"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout"),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", {
                            staticClass: "mr-5",
                            attrs: { sm3: "" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Postal Code",
                                  "browser-autocomplete": "off"
                                },
                                model: {
                                  value: _vm.addressPostalCode,
                                  callback: function($$v) {
                                    _vm.addressPostalCode = $$v
                                  },
                                  expression: "addressPostalCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { staticClass: "mr-5", attrs: { sm3: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent",
                              on: { click: _vm.createCompany }
                            },
                            [
                              _vm._v(
                                "\n              Create Company\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8871b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8871b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/NewCompany.vue
// module id = null
// module chunks = 